export default __webpack_public_path__ + "static/media/Northword Lines.61a925ee.png";